export enum PassengerIngestionExecutionStatus {
  Running = 'running',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export interface PassengerIngestionExecution {
  id: string;
  time: string;
  step: string;
  status: PassengerIngestionExecutionStatus;
  errorMessage?: string;
  passengerRecordCount: number;
  unmatchedCount: number;
  programs: PassengerIngestionProgram[];
  files: PassengerIngestionFile[];
}

interface PassengerIngestionProgram {
  name: string;
  passengerCount: number;
}

interface PassengerIngestionFile {
  name: string;
  type: string;
  time: string;
}
